<template>
  <div>
    <el-container style="height: 100vh;">
      <el-header height="0vh">
      </el-header>

      <el-main 
        class="no-scrollbar" 
        ref="container_content" 
        :style="'windows' === platform ? 
          dragging.last ? 
            'border: 5px dashed #409EFF; border-radius: 8px;' : 
            'border: 5px dashed #fff; border-radius: 8px;' : 
          ''">
        <div v-if="dragging.last" style="position: fixed; background: rgba(0, 0, 0, 0.3); left: 0; top: 0; width: 100vw; height: 100vh; z-index: 9999999;"></div>
        <el-row 
          :style="'windows' === platform ?
            { 
              cursor: 'pointer', 
              float: 'left', 
              width: '256px', 
              marginTop: '20px', 
              marginBottom: (objects.preview.length - 1) !== index ? '0px' : '128px' ,
              marginLeft: fileCardGap 
            } :
            { 
              display: 'flex', 
              marginTop: 0 === index && 'ios safari' === platform ? '64px' : '0px', 
              marginBottom: (objects.preview.length - 1) !== index ? '20px' : '96px' 
            }"
          v-for="(object, index) in objects.preview" 
          :key="index" 
          @click.native="showOperations(index)">
          <div>
            <el-image 
              draggable="false"
              :style="'windows' === platform ? 'width: 256px; height: 256px' : 'width: 64px; height: 64px'" 
              :src="object.picture" fit="contain"
              @load="() => onLoadedThumbnal(object)">
            </el-image>
          </div>
          <div :style="'windows' === platform ? 
            'size: 14px;':
            'width: calc(100% - 84px); size: 14px; text-align: left; margin-left: 20px'">
            <div 
              :style="'windows' === platform ? 
                'margin-top: 18px; height: 64px; line-height: 64px; color: #000; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;' : 
                'margin-top: 6px; height: 18px; line-height: 18px; color: #000; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;'">
              {{ object.name }}
            </div>
            <div 
              :style="'windows' === platform ? 
              'height: 64px; line-height: 18px; color: #999;' :
              'margin-top: 16px; height: 18px; line-height: 18px; color: #999;'">
              {{ object.fileSimplifiedModifiedTime }}  -  {{ object.size }}
            </div>
          </div>
        </el-row>        
      </el-main>

      <div style="width:96%; height:10vh; position:fixed; bottom: 0; left: 2%" >
        <el-button
          icon="el-icon-plus"
          type="primary"
          round
          style="width: 96%; margin-left: 2%; height: 5vh; font-weight: bold; font-size: 2.5vh; display: flex; justify-content: center; align-items: center;"
          @click="drawer.add.visible=true">
        </el-button>
      </div>
    </el-container>  

    <el-drawer
      :visible.sync="drawer.add.visible"
      :size="'windows' === platform ? 'calc(20% + 186px)' : '33%'"
      direction="btt">
      <div v-if="'windows' === platform" style="width: 100%; height: 55px;"></div>
      <div :style="'windows' === platform ?
        'height: 186px; display: flex; gap: 4%; padding: 0 4%;' :
        'display: flex; gap: 4%; padding: 0 4%;'">
          <el-card style="width: 100%; font-size: 200%" @click.native="pickAndPutObject">
            <div style="width: 100%">
              <i class="el-icon-document-add" :style="'windows' === platform ? 'margin-top: 46px;' : ''" />
               <div style="width: 100%; font-size: 1%;">上传文件</div>
            </div>
          </el-card>
          <el-card style="width: 100%; font-size: 200%" @click.native="putFolder">
            <div style="width: 100%">
              <i class="el-icon-folder-add" :style="'windows' === platform ? 'margin-top: 46px;' : ''" />
               <div style="width: 100%; font-size: 1%;">新建文件夹</div>
            </div>
          </el-card>
        </div>
    </el-drawer>

    <el-drawer
      :visible.sync="drawer.operations.visible"
      :size="'windows' === platform ? 'calc(20% + 656px)' : 'calc(33% + 420px)'"
      direction="btt">
      <div 
        @click="viewObject"
        style="width: 350px; height: 350px; position: relative;display: inline-block;">
        <el-image
          draggable="false" 
          :style="['video', 'music', 'image', 'pdf', 'word'].includes(drawer.operations.object.type) ? 
            'width: 350px; height: 350px; display: block; top: 50%; left: 50%; transform: translate(-50%, -50%); cursor: pointer; filter: brightness(0.3);' : 
            'width: 350px; height: 350px; display: block; top: 50%; left: 50%; transform: translate(-50%, -50%);'"
          :src="drawer.operations.object.picture" 
          fit="scale-down">
        </el-image>
        <i v-if="['video', 'music', 'image', 'pdf', 'word'].includes(drawer.operations.object.type)" 
          :class="['video', 'music'].includes(drawer.operations.object.type) ?
            'el-icon-video-play' :
            'el-icon-view'" 
          :style="{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '128px',
            color: 'rgba(255, 255, 255, 1)',
            cursor: 'pointer'
          }"> </i>
      </div>  
      <div :style="'windows' === platform ?
        'font-size: 20px; margin-top: 30px; height: 24px; line-height: 24px; color: #000; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;' :
        'font-size: 14px; margin-top: 10px; height: 20px; line-height: 20px; color: #000; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;'">
        {{ drawer.operations.visible ? drawer.operations.object.name : '' }}
      </div>
      <div :style="'windows' === platform ?
      'font-size: 20px; margin-top: 20px; margin-bottom: 80px; height: 20px; line-height: 20px; color: #999;' :
      'font-size: 14px; margin-bottom: 20px; height: 20px; line-height: 20px; color: #999;'">
        {{ drawer.operations.visible ? drawer.operations.object.fileSimplifiedModifiedTime + ' - ' + drawer.operations.object.size : '' }}
      </div>
      <div :style="'windows' === platform ?
        'height: 186px; display: flex; gap: 4%; padding: 0 4%;' :
        'display: flex; gap: 4%; padding: 0 4%;'">
          <el-card v-if="'windows' === platform" style="width: 100%; font-size: 200%" @click.native="openObject">
            <div style="width: 100%">
              <i class="el-icon-s-platform" :style="'windows' === platform ? 'margin-top: 46px;' : ''"/>
              <div style="width: 100%; font-size: 1%;">使用系统默认软件打开</div>
            </div>
          </el-card> 
          <el-card style="width: 100%; font-size: 200%" @click.native="downloadObject">
            <div style="width: 100%">
              <i class="el-icon-download" :style="'windows' === platform ? 'margin-top: 46px;' : ''" />
              <div style="width: 100%; font-size: 1%;">下载</div>
            </div>
          </el-card>
          <el-card style="width: 100%; font-size: 200%" @click.native="renameObject">
            <div style="width: 100%">
              <i class="el-icon-edit" :style="'windows' === platform ? 'margin-top: 46px;' : ''" />
              <div style="width: 100%; font-size: 1%;">重命名</div>
            </div>
          </el-card>
          <el-card style="width: 100%; font-size: 200%" @click.native="removeObject">
            <div style="width: 100%; ">
              <i class="el-icon-delete" :style="'windows' === platform ? 'margin-top: 46px;' : ''" />
              <div style="width: 100%; font-size: 1%; ">删除</div>
            </div>
          </el-card>
        </div>
    </el-drawer>
  </div>
</template>

<script>
import aliyun from '@/utils/aliyun';
import { ApplicationContext } from '@/utils/context';

export default {
  name: 'FileList',
  data: () => {
    return {
      drawer: {
        add: {
          visible: false
        },
        operations: {
          visible: false,
          object: {}
        }
      },
      initialized: false,
      objects: {
        loading: false,
        pageNum: 1,
        pageSize: 10,
        preview: [],
        total: []
      },
      fileCardGap: '',
      dragging: {
        last: false,
        current: false,
      }
    }
  },
  props: {
    platform: String
  },
  beforeCreate() {
  },
  methods: {
    handleDrop(event) {
      event.preventDefault();
      this.dragging.last = false;
      const files = event.dataTransfer.files;
      aliyun.putObject(files, () => {
        this.syncObjects(); 
        this.drawer.add.visible = false;
      });
    },
    handleDragOver(event) {
      event.preventDefault();
      this.dragging.last = true;
      this.dragging.current = true;
    },
    handleDragLeave(event) {
      event.preventDefault();
      let that = this;
      that.dragging.current = false;
      setTimeout(() => {
        if (!that.dragging.current) {
          that.dragging.last = false;
        }
      }, 10);
    },
    handleDragEnter(event) {
      event.preventDefault();
      this.dragging.last = true;
      this.dragging.current = true;
    },
    handleScroll() {
      console.log(1);
      let that = this;
      const scrollTop = that.$refs.container_content.$el.scrollTop;
      const scrollHeight = that.$refs.container_content.$el.scrollHeight;
      const clientHeight = that.$refs.container_content.$el.clientHeight;
      // 判断是否滑动到底部
      if (scrollTop + clientHeight >= scrollHeight * 0.95) {
        if (that.objects.loading) {
          return;
        }
        that.objects.loading = true;
        setTimeout(() => {
          that.objects.loading = false;
        }, 200);
        that.objects.pageNum++;
        that.objects.preview = that.objects.total.slice(0, that.objects.pageNum * that.objects.pageSize);
      }
    },
    onResize() {
      let width = this.$refs.container_content.$el.offsetWidth - 50;
      let fileCardCount = parseInt(width / 256);
      if ('windows' === this.platform) {
        this.objects.pageSize = fileCardCount * 2;
      }
      this.fileCardGap = ((width - fileCardCount * 256) / (fileCardCount + 1)) + 'px';
    },
    onLoadedThumbnal(object) {
      object.loaded = true;
      let cnt = 0;
      this.objects.total.forEach(o => {
        if (o.loaded) {
          cnt++;
        } 
      });
      if (cnt === this.objects.preview.length && !this.initialized) {
        this.initialized = true;
        ApplicationContext.$emit('on_loaded_file_list', null);
        this.$refs.container_content.$el.scrollTop = 0;
      }
    },
    showOperations(index) {
      this.drawer.operations = { 
        visible: true, 
        object: this.objects.total[index] 
      };
    },
    async syncObjects(onFinish) {
      this.objects.total = await aliyun.listObject();
      this.pageNum = 1;
      this.objects.preview = this.objects.total.slice(0, this.objects.pageSize);
      onFinish && onFinish();
    },
    async pickAndPutObject() {
      aliyun.pickAndPutObject(() => {
        this.syncObjects(); 
        this.drawer.add.visible = false;
      });
    },
    async viewObject() {
      ApplicationContext.$emit('do_viewing_file', this.drawer.operations.object);
    },
    async openObject() {
      var link = document.createElement('a');
      link.href = `netollie-cloud-disk-plugin://?type=do_viewing_object&objectName=${encodeURIComponent(this.drawer.operations.object.name)}&objectModifiedTime=${encodeURIComponent(this.drawer.operations.object.lastModified)}&objectUrl=${encodeURIComponent(this.drawer.operations.object.url)}`;
      link.click();
      this.drawer.operations = { visible: false, object: {} };
    },
    async downloadObject() {
      await aliyun.downloadObject(this.drawer.operations.object);
      this.drawer.operations = { visible: false, object: {} };
    },
    async renameObject() {
      this.$message({message: '即将推出，敬请期待。', type: 'warning'});
      // aliyun.renameObject(this.drawer.operations.object, 
      //   async () =>  {
      //     await this.syncObjects();
      //     this.drawer.operations = { visible: false, object: {} };
      //   },
      //   () => this.drawer.operations = { visible: false, object: {} });
    },
    async removeObject() {
      aliyun.removeObject(this.drawer.operations.object, 
        async () =>  {
          await this.syncObjects();
          this.drawer.operations = { visible: false, object: {} };
        },
        () => this.drawer.operations = { visible: false, object: {} });
    },
    putFolder() {
      this.$message({message: '即将推出，敬请期待。', type: 'warning'});
    },
  },
  mounted() {
    let that = this;
    that.onResize();
    that.syncObjects(() => {
      window.chrome 
        && window.chrome.webview 
        && setTimeout(() => window.chrome.webview.postMessage(JSON.stringify({ type : "initialized" })), 500);
    });
    window.addEventListener("dragenter", this.handleDragEnter);
    window.addEventListener("dragover", this.handleDragOver);
    window.addEventListener("dragleave", this.handleDragLeave);
    window.addEventListener("drop", this.handleDrop);
    this.$refs.container_content.$el.addEventListener('wheel', this.handleScroll);
    this.$refs.container_content.$el.addEventListener('touchstart', this.handleScroll);
    window.addEventListener("resize", this.onResize);
    
  },
  beforeDestroy() {
    window.removeEventListener("dragenter", this.handleDragEnter);
    window.removeEventListener("dragover", this.handleDragOver);
    window.removeEventListener("dragleave", this.handleDragLeave);
    window.removeEventListener("drop", this.handleDrop);
    this.$refs.container_content.$el.removeEventListener('wheel', this.handleScroll);
    this.$refs.container_content.$el.addEventListener('touchstart', this.handleScroll);
    window.removeEventListener("resize", this.onResize);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.no-scrollbar::-webkit-scrollbar {
  width: 0;
  height: 0;
  padding-top: env(safe-area-inset-top); 
}
</style>
